import {IMBoxSize} from "./box-size";

export interface IMPackage {
  amountOfCakes: number,
  weight: number,
  boxSize: IMBoxSize,
  ean: string,
}
